import NotesIcon from '@mui/icons-material/Notes';
import { Button, Menu, MenuItem } from '@mui/material';
import { MouseEvent, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDescriptionFooters } from '../../hooks/useDescriptionFooters';
import { useFragmentForm } from './useFragmentForm';

/**
 * Action menu to append a station-configured description footer to the fragment description field.
 */
export function DescriptionFooterSelector() {
  const { $t } = useIntl();
  const { watch, setValue } = useFragmentForm();
  const stationId = watch('stationId');
  const description = watch('description') || '';
  const footers = useDescriptionFooters(stationId);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(anchorEl);

  if (!footers.length) return null;

  function handleOpenMenu(event: MouseEvent<HTMLElement>) {
    setAnchorEl(event.currentTarget);
  }

  function handleCloseMenu() {
    setAnchorEl(null);
  }

  function handleSelectFooter(content: string) {
    setValue('description', description + content);
    handleCloseMenu();
  }

  return (
    <>
      <Button
        size="small"
        variant="outlined"
        color="secondary"
        startIcon={<NotesIcon />}
        onClick={handleOpenMenu}
        sx={{ alignSelf: 'flex-start', py: 0.25, fontSize: '12px' }}
      >
        {$t({
          id: 'fragments.form.footer.placeholder',
          defaultMessage: 'Agregar footer',
        })}
      </Button>
      <Menu anchorEl={anchorEl} open={menuOpen} onClose={handleCloseMenu}>
        {footers.map((footer) => (
          <MenuItem key={footer.name} onClick={() => handleSelectFooter(footer.content)}>
            {footer.name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
